import axios from "axios";

export const loginUser = async (formData) => {
  return await axios.post("/api/auth/login", formData, {
    withCredentials: true, // Ensures cookies are sent for session authentication
  });
};